import * as tslib_1 from "tslib";
export const login = (ruta) => {
    /* window.open('assets/php/cas-log/cas-login.php?ruta=','_self')  */
    //localStorage.setItem('usuario', 'DARIANA HERCILIA GÓMEZ REYES');
    //localStorage.setItem('correo', 'dariana.gomez@uc.cl');
};
//# sourceMappingURL=login.js.map